export const feedbackLink = "Dtuepd";
export default {feedbackLink};